import axios from 'axios';
import { customAxios } from '../../common/customAxios';

export const getUserOwnTractorPokesMeCount = (): Promise<number> => {
  return customAxios.get('/users-own-tractor-pokes/me/count');
};
